import fetch from '@/common/utils/ftFetch'

const baseName = "/ylwebsqsserviceonline"
const moduleList = {
  customerSession: `${baseName}/customerSession`,
  customerChatRecord: `${baseName}/customerChatRecord`
}

export const sessionHistoryApi = {
  // 列表
  reqList(params) {
    return fetch.post(`${moduleList.customerSession}/page`, params)
  },
  // 会话详情
  queryDetail(id) {
    return fetch.get(`${moduleList.customerChatRecord}/getChatRecord?sessionId=${id}`)
  },
  // 导出
  reqExcel: params => fetch.download(`${baseName}/report/customer_session/exportAsync`, { ...params }),
  // 获取淘天工单
  getTaoTianWorkOrder: sessionId => fetch.get(`${baseName}/agent/session/getTaoTianWorkOrder?sessionId=${sessionId}`)
}
